import React from "react";

const steps = [
  {
    id: 1,
    title: "Connect your data",
    description:
      "Securely connect your invoicing platform or upload PDFs/CSV. We enrich and verify buyer details automatically.",
    badge: "Tip: Connecting a tool speeds decisions to same-day.",
    badgeType: "success",
  },
  {
    id: 2,
    title: "Get a tailored offer",
    description:
      "We run credit and fraud checks, then present an advance rate and fee estimate that fits invoice risk and tenor.",
    statLabel: "Typical advance",
    statValue: "80–90%",
  },
  {
    id: 3,
    title: "Receive funds fast",
    description:
      "Accept with one click. Funds arrive in 24–48 hours to your business account.",
    statLabel: "Payout window",
    statValue: "24–48 hrs",
  },
  {
    id: 4,
    title: "Settle and repeat",
    description:
      "When your customer pays, we settle the discount automatically. Finance selective invoices anytime.",
    badge: "Rolling access to cash",
    badgeType: "neutral",
  },
];

const FourStepFlow = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-2xl font-semibold text-[#111827]">
            The 4-step flow
          </h2>

          <span className="hidden sm:inline-flex items-center gap-2 px-4 py-1 text-sm bg-white border rounded-full text-gray-600">
            🔒 Bank-grade security
          </span>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {steps.map((step) => (
            <div
              key={step.id}
              className="bg-[#FBFBFB] border border-gray-100 rounded-xl p-6"
            >
              {/* Step Number */}
              <div className="flex items-start gap-4 mb-4">
                <span className="flex items-center justify-center min-w-9 h-9 rounded-lg bg-[#D9F4EF] text-[#16A085] font-semibold">
                  {step.id}
                </span>

                <div>
                  <h3 className="font-semibold text-[#111827] mb-1">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>

              {/* Bottom Badge / Stat */}
              {step.badge && (
                <div
                  className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium
                    ${
                      step.badgeType === "success"
                        ? "bg-[#0FB9B1] text-white"
                        : "bg-gray-100 text-gray-600"
                    }`}
                >
                  {step.badge}
                </div>
              )}

              {step.statLabel && (
                <div className="mt-4 flex items-center justify-between bg-white border rounded-lg px-4 py-3">
                  <span className="text-sm text-gray-500">
                    {step.statLabel}
                  </span>
                  <span className="font-semibold text-[#111827]">
                    {step.statValue}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FourStepFlow;
